import React from 'react';
import PropTypes from 'prop-types';
import StructuredContent from '@nerdwallet/structured-content';
import { stringInputSpec, boolCheckboxSpec } from '../../lib/editing-configs';

const AutoInsuranceEntryPointWrapper = ({
  buttonAnnotation,
  buttonText,
  defaultZipCode,
  heading,
  pricingCode,
  subheading,
  isInternal,
  showQuotesOnSubmit,
  inventoryType,
  alternativeLayout,
  disablePopback,
}) => {
  return (
    <StructuredContent>
      {{
        type: 'AutoInsuranceEntryPoint',
        version: '1.0.0',
        props: {
          buttonAnnotation,
          buttonText,
          defaultZipCode,
          heading,
          pricingCode,
          subheading,
          isInternal,
          showQuotesOnSubmit,
          inventoryType,
          alternativeLayout,
          disablePopback,
        },
      }}
    </StructuredContent>
  );
};

AutoInsuranceEntryPointWrapper.propTypes = {
  /** Legal disclaimer displayed below the CTA */
  buttonAnnotation: PropTypes.string,
  /** Text on the CTA */
  buttonText: PropTypes.string,
  /** Default zipcode on first render */
  defaultZipCode: PropTypes.string,
  /** Heading text */
  heading: PropTypes.string,
  /** Partner's SRC code */
  pricingCode: PropTypes.string,
  /** Body text */
  subheading: PropTypes.string,
  /** Whether to redirect to in-house experience or partner's */
  isInternal: PropTypes.bool,
  /** Whether to hide the entry point and show the leave-behind (Auto-Insurance results) after submitting a valid zipCode */
  showQuotesOnSubmit: PropTypes.bool,
  /** Used to determine which experience the user chose to get offers */
  inventoryType: PropTypes.string,
  /** Enable alternative layout */
  alternativeLayout: PropTypes.bool,
  /** Disables the pop-back experience */
  disablePopback: PropTypes.bool,
};

AutoInsuranceEntryPointWrapper.defaultProps = {
  buttonAnnotation: 'Matches provided by Insure.com',
  buttonText: 'GET MY RATES',
  defaultZipCode: '94103',
  heading: 'See what you could save on car insurance',
  pricingCode: '664413',
  subheading:
    'Easily compare personalized rates to see how much switching car insurance could save you.',
  isInternal: false,
  showQuotesOnSubmit: false,
  inventoryType: 'nw-qs-leavebehind',
  alternativeLayout: false,
  disablePopback: false,
};

AutoInsuranceEntryPointWrapper.getEditingConfig = () => {
  return [
    stringInputSpec('buttonAnnotation', 'Button Annotation'),
    stringInputSpec('buttonText', 'Button Text'),
    stringInputSpec('defaultZipCode', 'Default Zip Code'),
    stringInputSpec('heading', 'Heading'),
    stringInputSpec('pricingCode', 'Pricing Code'),
    stringInputSpec('subheading', 'Subheading'),
    stringInputSpec('inventoryType', 'Inventory Type'),
    boolCheckboxSpec('isInternal', 'Is Internal'),
    boolCheckboxSpec('showQuotesOnSubmit', 'Show Quotes On Submit'),
    boolCheckboxSpec('alternativeLayout', 'Alternative Layout'),
    boolCheckboxSpec('disablePopback', 'Disable Popback'),
  ];
};

AutoInsuranceEntryPointWrapper.displayName = 'AutoInsuranceEntryPointWrapper';

export default AutoInsuranceEntryPointWrapper;
